import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	getUserSettings,
	userSettingsResolved,
	userSettingsRejected,
	updateUserSettings,
	updateUserSettingsResolved,
	updateUserSettingsRejected,
} from '../actions/userSettings.actions';

import { STATUS_ENUM, UserSettings } from '../types';

export interface UserSettingsState extends UserSettings {
	status: STATUS_ENUM;
}

export const initialUserSettingsState: UserSettingsState = {
	status: STATUS_ENUM.IDLE,
	selectedTheme: '',
};

export interface UserSettingsReducer {
	[x: string]: (
		state: UserSettingsState,
		action: AnyAction,
	) => UserSettingsState | undefined;
}

const reducer: UserSettingsReducer = {
	[getUserSettings.toString()]: state => ({
		...state,
		status: STATUS_ENUM.PENDING,
	}),
	[userSettingsResolved.toString()]: (state, action) => ({
		...state,
		...action.payload,
		status: STATUS_ENUM.SUCCESS,
	}),
	[userSettingsRejected.toString()]: state => ({
		...state,
		...initialUserSettingsState,
		status: STATUS_ENUM.ERROR,
	}),
	[updateUserSettings.toString()]: state => ({
		...state,
		status: STATUS_ENUM.PENDING,
	}),
	[updateUserSettingsResolved.toString()]: (state, action) => ({
		...state,
		...action.payload,
		status: STATUS_ENUM.SUCCESS,
	}),
	[updateUserSettingsRejected.toString()]: state => ({
		...state,
		...initialUserSettingsState,
		status: STATUS_ENUM.ERROR,
	}),
};

export default createReducer(initialUserSettingsState, reducer);
